import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./style.css";
import fetchSingleBlog from "../../utilities/fetchSingleBlog";
import { PortableText } from "@portabletext/react";
import components from "../../utilities/component";
import { DataContext } from "../../Context/Context";
import { client } from "../../sanityClient";

const BlogDetails = () => {
  const { blogs, setBlogs } = useContext(DataContext);
  const [blog, setBlog] = useState({});
  const [loading, setLoading] = useState(false);
  const { slug } = useParams();

  useEffect(() => {
    setLoading(true);
    const getBlog = async () => {
      try {
        const data = await fetchSingleBlog(slug);
        setBlog(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    if (slug) getBlog();
  }, [slug]);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "blog"] | order(publishedAt desc) {
          title,
          slug,
          author,
          publishedAt,
          mainImage{
            asset->{
              _id,
              url
            }
          },
          body
        }`
      )
      .then((data) => {
        setBlogs(data);
      })
      .catch(console.error);
  }, []);

  console.log(blogs);

  if (!blog) {
    return <p>Blog not found.</p>;
  }

  return (
    <section className="pt-24 pb-10">
      <div className="container flex lg:flex-row md:flex-row flex-col items-start gap-5">
        <div className="lg:w-[70%] md:w-[60%] w-full">
          {loading ? (
            <div className="flex w-full flex-col gap-4">
              <div className="skeleton h-56 w-full"></div>
              <div className="skeleton h-4 w-28"></div>
              <div className="skeleton h-4 w-full"></div>
              <div className="skeleton h-4 w-full"></div>
            </div>
          ) : (
            <>
              {/* Blog Title */}
              {loading ? (
                <div className="skeleton h-4 w-full"></div>
              ) : (
                <h1 className="text-2xl font-medium text-[#aca9a5] mb-4">
                  {blog.title}
                </h1>
              )}

              {/* Blog Date */}
              <p className="text-sm text-[#aca9a5] mb-6">
                {new Date(blog.publishedAt).toDateString()}
              </p>
              <div>
                {blog.categories?.map((category, index) => (
                  <div className="px-2 py-1 bg-green-100 inline-block text-green-500 rounded-lg mb-4">
                    {category.title}
                  </div>
                ))}
              </div>
              {/* Main Image */}
              <img
                src={blog.mainImageUrl}
                alt={blog.title}
                loading="lazy"
                className="w-full rounded-lg mb-6"
              />

              {/* Blog Content */}
              <div
                className="text-sm text-[#aca9a5] leading-relaxed"
                id="blog_description"
              >
                {/* {truncateDescription(blog.body, 99999)} */}
                <PortableText value={blog.body} components={components} />
              </div>

              {/* Additional Images */}
              {/* {blog.additionalImages?.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
                  {blog.additionalImages.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      loading="lazy"
                      alt=""
                      className="w-full rounded-lg"
                    />
                  ))}
                </div>
              )} */}
            </>
          )}
        </div>

        {/* Recommended Blogs */}
        <aside className=" lg:w-[30%] md:w-[40%] w-full">
          <h2 className="text-xl font-semibold text-[#aca9a5] mb-4">
            Recommended Blogs
          </h2>
          <div className="space-y-4">
            {blogs
              .filter((curr) => curr?.slug?.current !== blog?.slug?.current)
              ?.map((recommendedBlog, index) => (
                <div key={index} className="flex space-x-4">
                  <img
                    src={recommendedBlog?.mainImage.asset?.url}
                    alt={recommendedBlog?.title}
                    loading="lazy"
                    className="w-16 h-16 object-cover rounded-lg"
                  />
                  <div>
                    <h3 className="text-[15px] font-medium leading-[20px] text-[#aca9a5]">
                      {recommendedBlog?.title}
                    </h3>
                    <a
                      href={`/blog/${recommendedBlog.slug.current}`}
                      className="text-[#aca9a5] text-[14px] hover:text-[#aca9a5] hover:underline"
                    >
                      Read Article
                    </a>
                  </div>
                </div>
              ))}
          </div>
        </aside>
      </div>
    </section>
  );
};

export default BlogDetails;
